import React from 'react'
import CopyButton from './CopyButton'
import { Caption, Card, Text, Value } from './CopyField.styles'

interface CopyFieldProps {
	/** What the value is ("Trip code", "Public link"). */
	caption: string
	/** Shown on the left and placed on the clipboard by the button on the right. */
	value: string
	/** `code` gives the large monospace face used for short codes; `text` reads as body copy. */
	variant?: 'code' | 'text'
	/** Resting label on the copy control. */
	copyLabel?: string
	/** Toast shown when the clipboard refuses — say what could not be copied. */
	errorMessage?: string
	/** Locks the copy control (the value stays readable). */
	disabled?: boolean
	/** Native tooltip on the copy control, typically the reason it is disabled. */
	title?: string
	className?: string
}

/**
 * A value the user is meant to pass on: captioned, readable, and copied in one
 * press. The single surface for "here is your code / link" across the app, so
 * the trip code and the public share link cannot drift apart visually.
 */
const CopyField: React.FC<CopyFieldProps> = ({
	caption,
	value,
	variant = 'text',
	copyLabel,
	errorMessage,
	disabled,
	title,
	className,
}) => (
	<Card className={className}>
		<Text>
			<Caption>{caption}</Caption>
			<Value $variant={variant} title={value}>
				{value}
			</Value>
		</Text>
		<CopyButton
			value={value}
			label={copyLabel}
			errorMessage={errorMessage}
			disabled={disabled}
			title={title}
		/>
	</Card>
)

export default CopyField
